import React from 'react';
import Chip from '@mui/material/Chip';
import { TaskStatus } from '../../api/admin';
import { taskStatusLabel } from './taskOptions';

const COLOR: Record<TaskStatus, 'default' | 'warning' | 'success'> = {
	open: 'default',
	in_progress: 'warning',
	done: 'success',
};

interface Props {
	status: TaskStatus;
}

export default function TaskStatusChip({ status }: Props) {
	return <Chip size="small" variant="outlined" color={COLOR[status] ?? 'default'} label={taskStatusLabel(status)} />;
}
